import authReducer from "./authSlice";
import tabSelectedSlice from "../pages/onPremises/myScan/ScanDetails/TabSelection-slice";
import myScanSlice from './onPremMyscanSlice'
import globalFilterReducer from "./globalFilterSlice"
import Schedule_Slice, { setScheduleList } from "../pages/onPremises/myScan/Schedule_Slice";
import LoginDetailsSlice from "../../src/modules/authentication/login/Login_Details_slice";
import MyScanTable_Details_slice from "../pages/onPremises/myScan/MyScanTable_Details_slice";
import ComplianceWidgetSlice from "../pages/onPremises/ComplianceWidget.slice";
import CISComplianceSeleted from "../pages/CISCompliance.slice";
import eventManagerSlice from '../components/socket/event-manager.slice'
import IdleTimeout_slice from "../modules/authentication/idleTimeOut/idleTimeOut.slice"
import rereshFilterSlice from "./refreshActionSlice";
import configDiffSlice from "../pages/onPremises/ConfigDiff/ConfigDiff-slice";
const reducer = {
    auth: authReducer,
    OnPrem_DetailsSelectedTab: tabSelectedSlice,
    onPremMyScan: myScanSlice,
    globalFilter: globalFilterReducer,
    ScheduleList: Schedule_Slice,
    UserLoginDetails:LoginDetailsSlice,
    MyScanDetails:MyScanTable_Details_slice,
    ComplianceWidget:ComplianceWidgetSlice,
    ComplinaceTableSelectedRow: CISComplianceSeleted,
    eventManager: eventManagerSlice,
    idleTimeout:IdleTimeout_slice,
    refreshPage: rereshFilterSlice,
    configDiff: configDiffSlice
}


export default reducer